import { SherlatShakhsIcon } from "components/Icons/Icons";
import { InvoiceIcon } from "components/Icons/Icons";
import { KalaKhadamatIcon } from "components/Icons/Icons";
import { DashboardIcon } from "components/Icons/Icons";
import { KeyIcon } from "components/Icons/Icons";
import { KharidarIcon } from "components/Icons/Icons";
import { SettingsIcon } from "components/Icons/Icons";
import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  ExitIcon,
  SupportIcon,
  GlobeIcon,
  CartIcon,
} from "components/Icons/Icons";

export const USER_SIDEBAR_MENU = [
  {
    path: "/user/dashboard",
    name: "داشبورد",
    icon: <DashboardIcon color="inherit" />,
  },

  /* {
    separator: "تعاریف",
  }, */

  {
    path: "/user/sherkat",
    name: "شخص/ شرکت",
    icon: <SherlatShakhsIcon color="inherit" />,
  },
  {
    path: "/user/kala",
    name: "کالا/خدمات",
    icon: <KalaKhadamatIcon color="inherit" />,
  },
  {
    path: "/user/tarafhesab",
    name: "طرف حساب/خریدار",
    icon: <KharidarIcon color="inherit" />,
  },
  {
    path: "/user/sodorhesab",
    name: " صورتحساب",
    icon: <InvoiceIcon color="inherit" />,
  },

 /*  {
    separator: "امکانات",
  }, */

  {
    path: "/user/sodorcsr",
    name: "صدور گواهی CSR",
    icon: <KeyIcon color="inherit" />,
  },

  {
    path: "/setting",
    name: "تنظیمات",
    icon: <SettingsIcon color="inherit" />,
  },
  {
    path: "/user/profile",
    name: "مشخصات کاربری",
    icon: <PersonIcon color="inherit" />,
  },
];


export const LOGO_TEXT = "سامانه مودیان";

export const USER_TYPE = ["حقیقی", "حقوقی"];
export const KALA_TYPE = [
  { title: "کالا", value: true },
  { title: "خدمات", value: false },
];
export const KALA_VAHED = [
  { title: "لنگه", value: "1611" },
  { title: "عدل", value: "1612" },
  { title: "جعبه", value: "1613" },
  { title: "توپ", value: "1618" },
  { title: "ست", value: "1619" },
  { title: "دست", value: "1620" },
  { title: "کارتن", value: "1624" },
  { title: "عدد", value: "1627" },
  { title: "بسته", value: "1628" },
  { title: "پاکت", value: "1629" },
  { title: "دستگاه", value: "1631" },
  { title: "تخته", value: "1640" },
  { title: "رول", value: "1641" },
  { title: "طاقه", value: "1642" },
  { title: "جفت", value: "1643" },
  { title: "متر مربع", value: "1645" },
  { title: "پالت", value: "1649" },
  { title: "دوجین", value: "1661" },
  { title: "رینگ (حلقه)", value: "1668" },
  { title: "قراص", value: "1673" },
  { title: "قراصه", value: "1694" },
  { title: "لیتر", value: "1637" },
  { title: "ساشه", value: "1650" },
  { title: "کپسول", value: "1683" },
  { title: "بندیل", value: "1656" },

  { title: "رول (حلقه)", value: "1630" },
  { title: "قالب", value: "163" },
  { title: "شانه", value: "1660" },
  { title: "متر مكعب", value: "1647" },
  { title: "ثوب", value: "1689" },
  { title: "نیم دوجین", value: "1690" },
  { title: "قرقره", value: "1635" },
  { title: "کیلوگرم", value: "164" },
  { title: "بطری", value: "1638" },
  { title: "برگ", value: "161" },
  { title: "سطل", value: "1625" },
  { title: "ورق", value: "1654" },
  { title: "شاخه", value: "1646" },
  { title: "قوطي", value: "1644" },
  { title: "جلد", value: "1617" },
  { title: "تیوب", value: "162" },
  { title: "متر", value: "165" },
  { title: "کلاف", value: "1610" },
  { title: "کیسه", value: "1615" },
  { title: "طغرا", value: "1680" },
  { title: "بشكه", value: "1639" },
  { title: "گالن", value: "1614" },
  { title: "فاقد بسته بندی", value: "1687" },
  { title: "کارتن", value: "1693" },
  { title: "صفحه", value: "166" },

  { title: "مخزن", value: "1666" },
  { title: "تانكر", value: "1626" },
  { title: "دبه", value: "1648" },
  { title: "سبد", value: "1684" },
  { title: "تن", value: "169" },
  { title: "بانكه", value: "1651" },
  { title: "سیلندر", value: "1633" },
  { title: "فوت مربع", value: "1679" },

  { title: "حلب", value: "168" },
  { title: "شیت", value: "1665" },
  { title: "چلیك", value: "1659" },
  { title: "جام", value: "1636" },
  { title: "گرم", value: "1622" },
  { title: "نخ", value: "1616" },
  { title: "شعله", value: "1652" },
  { title: "قیراط", value: "1678" },
  { title: "میلي لیتر", value: "16100" },
  { title: "میلي متر", value: "16101" },
  { title: "میلي گرم", value: "16102" },
  { title: "ساعت", value: "16103" },
  { title: "روز", value: "16104" },
  { title: "تن کیلومتر", value: "16105" },
  { title: "کیلووات ساعت", value: "1669" },
  { title: "نفر", value: "1676" },
  { title: "ثانیه", value: "16110" },

  { title: "دقیقه", value: "16111" },
  { title: "ماه", value: "16112" },
  { title: "سال", value: "16113" },
  { title: "قطعه", value: "16114" },
  { title: "سانتي متر", value: "16115" },
  { title: "سانتي متر مربع", value: "16116" },
  { title: "فروند", value: "1632" },
  { title: "واحد", value: "1653" },
  { title: "لیوان", value: "16108" },
  { title: "نوبت", value: "16117" },
  { title: "مگا وات ساعت", value: "16118" },
  { title: "گیگا بایت بر ثانیه", value: "16119" },
  { title: "ویال", value: "1681" },
  { title: "دیسک (حلقه)", value: "1667" },
  { title: "نسحه (جلد)", value: "16120" },
  { title: "نفر- ساعت", value: "16121" },
  { title: "کیلومتر", value: "16122" },
  { title: "آمپر", value: "16125" },
  { title: "میلي آمپر", value: "16126" },
  { title: "مثقال", value: "16127" },
  { title: "سیر", value: "16128" },
  { title: "دفعه", value: "16129" },
  { title: "مگا یونیت", value: "16130" },
  { title: "کادر", value: "16131" },
  { title: "پرس", value: "16132" },
];

export const ITEM_STATUS = [
  { title: "فعال", value: true },
  { title: "غیرفعال", value: false },
];
export const ITEM_YES_NO = [
  { title: "بله", value: true },
  { title: "خیر", value: false },
];
export const ITEM_RELATIONTYPE = [
  { title: "با گواهی امضا", value: true },
  { title: "بدون گواهی امضا", value: false },
];
export const TARAF_HESAB_TYPE = [
  { title: "حقیقی", value: "1" },
  { title: "حقوقی", value: "2" },
  { title: "مشارکت مدنی", value: "3" },
  { title: "اتباع غیر ایرانی", value: "4" },
];
export const SORATHESAB_PATTERN = [
  "فروش",
  "فروش ارز",
  "صورتحساب طلا،جواهر و پلاتین",
  "قرارداد پیمانکاری",
  "قبوض خدماتی",
  "بلیط هواپیما",
  "صادرات",
];
export const SORATHESAB_TYPE_TASFIE = ["نقد", "نسیه", "نقد/نسیه"];
export const SORATHESAB_TYPE = ["نوع اول", "نوع دوم"];
export const SORATHESAB_SUBJECT_FILTER = [
  { text: "اصلی", value: "1" },
  { text: "اصلاحی", value: "2" },
  { text: "ابطالی", value: "3" },
  { text: "برگشتی", value: "4" },
];
export const SORATHESAB_TYPE_FILTER = [
  { text: "اول", value: "1" },
  { text: "دوم", value: "2" },
  /* { text: "سوم", value: "3" }, */
];
export const SORATHESAB_PATTERN_FILTER = [
  { text: "فروش", value: "1" },
  { text: "فروش ارز", value: "2" },
  { text: "صورتحساب طلا,جواهر و پلاتین", value: "3" },
  { text: "قراردادپیمانکاری", value: "4" },
  { text: "قبوض خدماتی", value: "5" },
  { text: "بلیط هواپیما", value: "6" },
  { text: "صادرات", value: "7" },
];
export const SORATHESAB_TASVIYE_FILTER = [
  { text: "نقد", value: "1" },
  { text: "نسیه", value: "2" },
  { text: "نقد/نسیه", value: "3" },
];

export const SAL_MALI = [
  "1400",
  "1401",
  "1402",
  "1403",
  "1404",
  "1405",
  "1406",
  "1407",
  "1408",
];

export const MOCK_DATA = [];

export const KALA_SHENASEH_TYPE = [
  {
    value: 0,
    title: "",
  },
  {
    value: 1,
    title: "عمومي - خدمت",
  },
  {
    value: 2,
    title: "اختصاصي - خدمت",
  },
  {
    value: 3,
    title: "عمومي - داخلي",
  },
  {
    value: 4,
    title: "عمومي - وارداتي",
  },
  {
    value: 5,
    title: "اختصاصي - داخلي",
  },
  {
    value: 6,
    title: "اختصاصي - وارداتي",
  },
];

export const SORATHESAB_PATTERN_PEYMANKARI = 4;

export const PROVINCES = [
  "آذربایجان شرقی",
  "آذربایجان غربی",
  "اردبیل",
  "اصفهان",
  "البرز",
  "ایلام",
  "بوشهر",
  "تهران",
  "چهارمحال و بختیاری",
  "خراسان جنوبی",
  "خراسان رضوی",
  "خراسان شمالی",
  "خوزستان",
  "زنجان",
  "سمنان",
  "سیستان و بلوچستان",
  "فارس",
  "قزوین",
  "قم",
  "کردستان",
  "کرمان",
  "کرمانشاه",
  "کهگیلویه و بویراحمد",
  "گلستان",
  "گیلان",
  "لرستان",
  "مازندران",
  "مرکزی",
  "هرمزگان",
  "همدان",
  "یزد",
];

export const CITIES = {
  "آذربایجان شرقی": [
    "تبریز",
    "مراغه",
    "مرند",
    "میانه",
    "اهر",
    "هریس",
    "شبستر",
    "بناب",
    "ملکان",
    "سراب",
    "کلیبر",
    "ورزقان",
    "آذرشهر",
    "هشترود",
    "عجب‌شیر",
    "جلفا",
    "چاراویماق",
    "اسکو",
    "بستان‌آباد",
    "صوفیان",
    "خداآفرین",
  ],
  "آذربایجان غربی": [
    "ارومیه",
    "خوی",
    "مهاباد",
    "بوکان",
    "میاندوآب",
    "سلماس",
    "نقده",
    "پیرانشهر",
    "تکاب",
    "شاهین‌دژ",
    "ماکو",
    "چالدران",
    "سردشت",
    "اشنویه",
    "پلدشت",
    "چایپاره",
    "شوط",
  ],
  اردبیل: [
    "اردبیل",
    "پارس‌آباد",
    "مشگین‌شهر",
    "خلخال",
    "گرمی",
    "بیله‌سوار",
    "کوثر",
    "نیر",
    "نمین",
    "سرعین",
  ],
  اصفهان: [
    "اصفهان",
    "کاشان",
    "نجف‌آباد",
    "خمینی‌شهر",
    "شاهین‌شهر",
    "فلاورجان",
    "زرین‌شهر",
    "گلپایگان",
    "نطنز",
    "اردستان",
    "سمیرم",
    "خوانسار",
    "دولت‌آباد",
    "مبارکه",
    "نایین",
    "شهرضا",
    "فریدن",
    "فریدون‌شهر",
    "دهاقان",
    "تیران",
    "کرون",
    "آران و بیدگل",
    "بوئین و میاندشت",
    "چادگان",
    "خور",
    "لنجان",
  ],
  البرز: [
    "کرج",
    "فردیس",
    "هشتگرد",
    "نظرآباد",
    "طالقان",
    "اشتهارد",
    "ماهدشت",
    "محمدشهر",
    "مشکین‌دشت",
    "چهارباغ",
    "کمال‌شهر",
    "گلستان",
  ],
  ایلام: [
    "ایلام",
    "دهلران",
    "ایوان",
    "آبدانان",
    "دره‌شهر",
    "مهران",
    "ملکشاهی",
    "شیروان چرداول",
    "بدره",
    "سیروان",
  ],
  بوشهر: [
    "بوشهر",
    "برازجان",
    "گناوه",
    "دیلم",
    "کنگان",
    "جم",
    "عسلویه",
    "دیر",
    "دشتستان",
    "تنگستان",
    "دشتی",
  ],
  تهران: [
    "تهران",
    "اسلامشهر",
    "شهریار",
    "قدس",
    "ملارد",
    "ورامین",
    "قرچک",
    "پاکدشت",
    "ری",
    "دماوند",
    "فیروزکوه",
    "پردیس",
    "رباط‌کریم",
    "بهارستان",
    "شمیرانات",
    "پیشوا",
    "رودهن",
    "بومهن",
    "کهریزک",
    "نسیم‌شهر",
    "اندیشه",
    "صباشهر",
    "گلستان",
    "فردوسیه",
    "احمدآباد مستوفی",
  ],
  "چهارمحال و بختیاری": [
    "شهرکرد",
    "بروجن",
    "فارسان",
    "لردگان",
    "کیار",
    "اردل",
    "کوهرنگ",
    "سامان",
    "بن",
  ],
  "خراسان جنوبی": [
    "بیرجند",
    "قائن",
    "طبس",
    "فردوس",
    "نهبندان",
    "سرایان",
    "بشرویه",
    "درمیان",
    "سربیشه",
    "زیرکوه",
    "خوسف",
  ],
  "خراسان رضوی": [
    "مشهد",
    "نیشابور",
    "سبزوار",
    "تربت حیدریه",
    "قوچان",
    "کاشمر",
    "تربت جام",
    "چناران",
    "گناباد",
    "خواف",
    "درگز",
    "کلات",
    "سرخس",
    "فریمان",
    "تایباد",
    "باخرز",
    "بردسکن",
    "خلیل‌آباد",
    "رشتخوار",
    "جوین",
    "مه‌ولات",
  ],
  "خراسان شمالی": [
    "بجنورد",
    "شیروان",
    "اسفراین",
    "جاجرم",
    "فاروج",
    "گرمه",
    "راز و جرگلان",
    "مانه و سملقان",
  ],
  خوزستان: [
    "اهواز",
    "آبادان",
    "خرمشهر",
    "دزفول",
    "اندیمشک",
    "بهبهان",
    "ماهشهر",
    "ایذه",
    "مسجدسلیمان",
    "شادگان",
    "رامهرمز",
    "شوش",
    "شوشتر",
    "آغاجاری",
    "امیدیه",
    "باغ‌ملک",
    "بندر ماهشهر",
    "حمیدیه",
    "دشت آزادگان",
    "رامشیر",
    "سوسنگرد",
    "گتوند",
    "لالی",
    "هندیجان",
    "هویزه",
    "کارون",
    "اروندکنار",
  ],
  زنجان: [
    "زنجان",
    "ابهر",
    "خرمدره",
    "قیدار",
    "ماه‌نشان",
    "طارم",
    "ایجرود",
    "سلطانیه",
  ],
  سمنان: [
    "سمنان",
    "شاهرود",
    "دامغان",
    "گرمسار",
    "مهدیشهر",
    "سرخه",
    "میامی",
    "آرادان",
  ],
  "سیستان و بلوچستان": [
    "زاهدان",
    "چابهار",
    "ایرانشهر",
    "زابل",
    "خاش",
    "سراوان",
    "سرباز",
    "کنارک",
    "نیکشهر",
    "میرجاوه",
    "زهک",
    "هیرمند",
    "دلگان",
    "قصرقند",
    "راسک",
    "نیمروز",
    "فنوج",
    "بمپور",
  ],
  فارس: [
    "شیراز",
    "مرودشت",
    "کازرون",
    "جهرم",
    "فسا",
    "لار",
    "داراب",
    "نی‌ریز",
    "اقلید",
    "آباده",
    "سپیدان",
    "کوار",
    "فیروزآباد",
    "ممسنی",
    "استهبان",
    "ارسنجان",
    "صفاشهر",
    "شیرین‌سو",
    "قیر",
    "خرامه",
    "لامرد",
    "مهر",
    "رستم",
    "زرین‌دشت",
    "پاسارگاد",
    "خنج",
  ],
  قزوین: [
    "قزوین",
    "تاکستان",
    "الوند",
    "آبیک",
    "بوئین‌زهرا",
    "محمدیه",
    "آوج",
    "البرز",
  ],
  قم: ["قم", "جعفریه", "دستجرد", "قنوات", "کهک", "سلفچگان"],
  کردستان: [
    "سنندج",
    "سقز",
    "مریوان",
    "بانه",
    "قروه",
    "کامیاران",
    "بیجار",
    "دیواندره",
    "سروآباد",
    "دهگلان",
  ],
  کرمان: [
    "کرمان",
    "رفسنجان",
    "جیرفت",
    "بم",
    "زرند",
    "سیرجان",
    "بافت",
    "کهنوج",
    "شهربابک",
    "بردسیر",
    "رابر",
    "رودبار جنوب",
    "عنبرآباد",
    "قلعه گنج",
    "ریگان",
    "انار",
    "ارزوئیه",
    "فهرج",
    "منوجان",
    "نرماشیر",
  ],
  کرمانشاه: [
    "کرمانشاه",
    "اسلام‌آباد غرب",
    "جوانرود",
    "سنقر",
    "هرسین",
    "کنگاور",
    "پاوه",
    "صحنه",
    "قصرشیرین",
    "گیلان‌غرب",
    "سرپل ذهاب",
    "روانسر",
    "ثلاث باباجانی",
    "دالاهو",
  ],
  "کهگیلویه و بویراحمد": [
    "یاسوج",
    "دوگنبدان",
    "دهدشت",
    "لیکک",
    "سی‌سخت",
    "گچساران",
    "باشت",
    "چرام",
    "بهمئی",
  ],
  گلستان: [
    "گرگان",
    "گنبد کاووس",
    "علی‌آباد",
    "آق‌قلا",
    "بندرترکمن",
    "کردکوی",
    "مینودشت",
    "بندرگز",
    "آزادشهر",
    "رامیان",
    "کلاله",
    "مراوه‌تپه",
    "گالیکش",
    "گمیشان",
  ],
  گیلان: [
    "رشت",
    "بندر انزلی",
    "لاهیجان",
    "لنگرود",
    "آستارا",
    "تالش",
    "رودسر",
    "فومن",
    "صومعه‌سرا",
    "رودبار",
    "املش",
    "ماسال",
    "شفت",
    "آستانه اشرفیه",
    "رضوانشهر",
    "سیاهکل",
  ],
  لرستان: [
    "خرم‌آباد",
    "بروجرد",
    "دورود",
    "کوهدشت",
    "الیگودرز",
    "نورآباد",
    "ازنا",
    "پلدختر",
    "الشتر",
    "رومشکان",
    "چگنی",
    "دلفان",
  ],
  مازندران: [
    "ساری",
    "بابل",
    "آمل",
    "قائمشهر",
    "نوشهر",
    "چالوس",
    "تنکابن",
    "بهشهر",
    "بابلسر",
    "رامسر",
    "نکا",
    "محمودآباد",
    "جویبار",
    "نور",
    "فریدونکنار",
    "کلاردشت",
    "عباس‌آباد",
    "گلوگاه",
    "سوادکوه",
    "میاندورود",
    "سیمرغ",
  ],
  مرکزی: [
    "اراک",
    "ساوه",
    "خمین",
    "محلات",
    "دلیجان",
    "تفرش",
    "شازند",
    "کمیجان",
    "آشتیان",
    "زرندیه",
    "خنداب",
    "فراهان",
  ],
  هرمزگان: [
    "بندرعباس",
    "میناب",
    "قشم",
    "کیش",
    "بندرلنگه",
    "حاجی‌آباد",
    "پارسیان",
    "جاسک",
    "بستک",
    "رودان",
    "سیریک",
    "ابوموسی",
    "بندر خمیر",
  ],
  همدان: [
    "همدان",
    "ملایر",
    "نهاوند",
    "تویسرکان",
    "کبودرآهنگ",
    "اسدآباد",
    "رزن",
    "بهار",
    "فامنین",
  ],
  یزد: [
    "یزد",
    "میبد",
    "اردکان",
    "بافق",
    "مهریز",
    "اشکذر",
    "تفت",
    "ابرکوه",
    "خاتم",
    "بهاباد",
  ],
};
